import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useFormik } from "formik";
import axios from "axios";
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';

const validationSchema = Yup.object().shape({
    parameters: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required('Parameter is required')
      })
    ).min(1, 'At least one parameter is required'),
});

export default function AddParameters({type, editId, setEditId, show, setShow, loading, setLoading, getList, brandId, setBrandId, showCompetitors, setShowCompetitors,...rest}){
    const [parameters, setParameters] = useState([{ id: '', name: '' }]);
    const initialValues = {
        id: editId,
        brandId: brandId,
        parameters: parameters
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            handleSubmit(values);
        },
    });

    useEffect(() => {
        if (brandId !== null){
            formik.setFieldValue('brandId', brandId);
        }
    },[]);
    
    useEffect(() => {
        if(editId > 0){
            axios.get(`api/parameter?brandId=${brandId}`) 
            .then(res => {
                if (res.data.success) {
                    const parameterData = res.data.data;
                    // console.log("parameterData===",parameterData)
                    if(parameterData.length > 0 ){
                        formik.setValues({
                            parameters: parameterData.map(paramater => ({ id: paramater.id, name: paramater.name }))
                        });
                        setParameters(parameterData.map(paramater => ({ id: paramater.id, name: paramater.name })));
                    }
                    else{
                        setParameters([{ id: '', name: '' }])
                    }
                } else {
                    console.error("Error fetching parameter:", res.data.message);
                }
            })
            .catch(error => {
                console.error("Error fetching parameter:", error.message);
            });
        }  else {
            formik.resetForm();
            setParameters([{ id: '', name: '' }]);
        }
    },[show, brandId]);

    const handleAddParameter = () => {
        setParameters([...parameters, { id: '', name: '' }]);
    };

    const handleRemoveParameter = (index) => {
        const parameterId = parameters[index].id;
        if(parameterId === ''){            
            setParameters(parameters.filter((_, i) => i !== index));
            formik.setFieldValue('parameters', parameters.filter((_, i) => i !== index));
            return;
        }
        else{
            Swal.fire({
                title: 'Are you sure you want to delete this parameter?',
                showCancelButton: true,
                confirmButtonColor: '#087f43',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) { 
                    const updatedParameters = parameters.filter((_, i) => i !== index);
                    setParameters(updatedParameters);
                    formik.setFieldValue('parameters', updatedParameters);
                    axios.delete(`/api/parameter/delete?id=${parameterId}`).then((res) =>{
                        if(res.data.success){                             
                            Swal.fire('Deleted!', '', 'success')
                            // setParameters(parameters.filter((_, i) => i !== index));                            
                        } 
                    }).catch((error) => {
                        console.log(error);                     
                        Swal.fire(error.message, '', 'info')           
                    });
                } else if (result.isDenied) {
                Swal.fire('Cancelled!', '', 'info')
                }
            })
        }
    };

    const handleChange = (index, event) => {
        const newParameters = [...parameters];
        newParameters[index] = {
            ...newParameters[index],
            name: event.target.value
        };
        setParameters(newParameters);
        formik.setFieldValue('parameters', newParameters);
    };

    const handleClose = () => setShow(false);

    const handleCloseModal = () => {
        formik.resetForm(); 
        handleClose(); 
    };

    const handleSubmit = (values) => {
        if(brandId === null){
            Swal.fire('Brand Id cannot be null', '', 'warning');
            return; 
        }
        values.brandId = brandId
        setLoading(true);
        const apiCall = editId > 0 ? axios.put : axios.post;
        const apiUrl = editId > 0 ? `api/parameter/update` : `api/parameter/create`;
        apiCall(apiUrl, values).then(res => {
            setLoading(false);
            setShow(false);
            if (res.data.success) {
                Swal.fire(res.data.message, '', 'success').then(() => {
                    getList();
                    formik.resetForm();
                    if(editId <= 0){
                        setShowCompetitors(true);
                    }
                    // setShowCompetitors(false);
                });
            } else {
                Swal.fire(res.data.message, '', 'error');
            }
        }).catch((error) => {
            setLoading(false);
            setShow(false);
            Swal.fire(error.response.data.message, '', 'error');
        });
    };
    
    return (
        <Modal show={show} onHide={handleCloseModal} size='lg' backdrop="static">
            <form autoComplete="off" onSubmit={formik.handleSubmit} encType="multipart/form-data">
                <Modal.Header>
                    <h1 className="modal-title" id="addUploadLabel">{type} Parameters</h1>
                    <Link className="ss-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleCloseModal}>
                        <i className="fa-solid fa-xmark"></i>
                    </Link>
                </Modal.Header>
                <Modal.Body>
                {parameters.map((param, index) => (
                    <div className="row" key={index}>
                        <div className="col-md-12">
                            <div className="">
                                <div className='align-items-center row mb-2'>
                                    <div className="col-lg-2 col-md-12">
                                        <label htmlFor={`parameter-${index}`} className="mb-0 form-label"> {`Parameter ${index + 1}`}</label>
                                    </div>
                                    <div  className="col-lg-9 col-md-11 col-9 px-md-1">
                                        <input
                                            type="text"
                                            id={`parameter-${index}`}
                                            className="form-control"
                                            name={`parameters[${index}].name`}
                                            value={param.name}
                                            onChange={(event) => handleChange(index, event)}
                                            onBlur={formik.handleBlur}
                                        />
                                
                                        {formik.touched.parameters && formik.errors.parameters && formik.errors.parameters[index] && formik.errors.parameters[index].name && (
                                            <div className="text-danger errorMSG">{formik.errors.parameters[index].name}</div>
                                        )}
                                    </div>
                                    {index === 0 ? (
                                        <div className='col-lg-1 col-md-1 col px-md-1'>
                                            <button type="button" className="save-btn p-7px-10px" onClick={handleAddParameter} >
                                                <i className="fa-solid fa-plus"></i>
                                            </button>
                                        </div>
                                    ) : (
                                        <div className='col-lg-1 col-md-1 col px-md-1'>
                                            <button type="button" className="save-btn bg-danger-subtle p-7px-12px" onClick={() => handleRemoveParameter(index)} >
                                                <i className="fa-solid fa-close text-danger"></i>
                                            </button>
                                        </div>
                                    )}                                    
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="add-btn" onClick={handleCloseModal}>
                        Close
                    </button>
                    <button type="submit" className="save-btn" disabled={loading}>
                        {loading ? 'Processing...' : 'Save'}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    );
}
 